define(
    'NMSDesignSystem.ProductPrice.Shopping',
    [
        'ProductViews.Price.View',
        'Profile.Model',
        'nms_product_price.tpl'
    ],
    function NMSDesignSystemProductPriceShopping(
        ProductViewsPriceView,
        ProfileModel,
        nmsProductPriceTpl
    ) {
        'use strict';

        ProfileModel = ProfileModel.ProfileModel || ProfileModel;
        var loginToSeePriceField = 'custitem_awa_login_to_see_price';

        function getItemValue(item, fieldId) {
            if (!item) {
                return null;
            }

            return typeof item.get === 'function' ? item.get(fieldId) : item[fieldId];
        }

        function resolveItem(model) {
            return model && (
                typeof model.getItem === 'function' && model.getItem() ||
                typeof model.get === 'function' && model.get('item') ||
                model.item
            );
        }

        function isEnabled(value) {
            return value === true || value === 'T' || value === 'true' || value === 1 || value === '1';
        }

        function localPreviewLoginUrl() {
            var location = typeof window !== 'undefined' && window.location;

            if (!location || !/shopping-local\.ssp$/i.test(location.pathname)) {
                return '';
            }

            return location.origin +
                location.pathname.replace(/shopping-local\.ssp$/i, 'checkout-local.ssp') +
                '?is=login&login=T#login-register';
        }

        return ProductViewsPriceView.extend({
            template: nmsProductPriceTpl,

            getContext: function getNMSProductPriceContext() {
                var context = ProductViewsPriceView.prototype.getContext.apply(this, arguments);
                var isLoggedIn = ProfileModel.getInstance().get('isLoggedIn') === 'T';
                var previewLoginUrl = localPreviewLoginUrl();
                var productsLoginPrice = !!this.options.nmsLoginToBuy &&
                    !isLoggedIn &&
                    isEnabled(getItemValue(resolveItem(this.model), loginToSeePriceField));

                context.isLoggedIn = isLoggedIn;
                context.nmsLoginToBuy = productsLoginPrice;
                if (productsLoginPrice || !isLoggedIn && !context.isPriceEnabled) {
                    context.isPriceEnabled = false;
                    context.isPriceVisible = false;
                }
                if (previewLoginUrl) {
                    context.urlLogin = previewLoginUrl;
                }

                return context;
            }
        });
    }
);
